import React from 'react';

import { IIconProps, TIconType } from '../interface';

const RefreshIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
			{...props?.innerSvgProps}
		>
			<path
				d='M14 15L10 19L14 23'
				stroke='#2E2E6B'
			/>
			<path
				d='M18.0622 8.5C18.7138 9.62862 19.0374 10.9167 18.9966 12.2193C18.9557 13.5219 18.5521 14.7872 17.8311 15.8728C17.11 16.9584 16.1003 17.8212 14.9155 18.364C13.7307 18.9067 12.4179 19.108 11.1249 18.9451'
				stroke='#2E2E6B'
				strokeLinecap='round'
			/>
			<path
				d='M10 9L14 5L10 1'
				stroke='#2E2E6B'
			/>
			<path
				d='M5.93782 15.5C5.27676 14.355 4.95347 13.0462 5.0054 11.7251C5.05733 10.404 5.48234 9.12457 6.23124 8.03498C6.98013 6.9454 8.02229 6.09019 9.23708 5.56834C10.4519 5.04649 11.7896 4.87934 13.0955 5.08625'
				stroke='#2E2E6B'
				strokeLinecap='round'
			/>
		</svg>
	);
};

export default RefreshIcon;
